<modal #modal>
  <div class="modal-wrapper">
    <button type="button" class="close" (click)="closeModal()">
      <img src="../../../../../assets/icons/close-b.svg" />
    </button>
    <h2>Trækning den 15. hver måned</h2>
    <div>Fra oktober 2024 trækker og offentliggør vi alle vindere den 15. i hver måned.</div>
    <br>
    <div>Det betyder at vi den 15. kl. 15.00 offentliggør alle resultater her på siden.</div>
    <br>
    <div class="text-center">
      <button (click)="closeModal()">OK</button>
    </div>
    <br>
    <div class="text-center">læs mere på</div>
    <div class="lp-link text-center" (click)="navigateToLP()">www.klasselotteriet.dk/15</div>
  </div>
</modal>
